import React from 'react';
import { Building2, DollarSign, Tag, ArrowLeft, Users, BarChart, Target } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Advertise() {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <Link
          to="/"
          className="flex items-center text-blue-600 hover:text-blue-800 mb-4"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Home
        </Link>
        <h1 className="text-3xl font-bold">Advertising with Fuel Central</h1>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6 mb-10">
        <div className="flex flex-col md:flex-row items-center mb-8">
          <div className="bg-blue-100 p-5 rounded-full mr-6 mb-4 md:mb-0">
            <Building2 className="w-12 h-12 text-blue-600" />
          </div>
          <div>
            <h2 className="text-2xl font-bold mb-2">Reach Decision Makers in the Gas Industry</h2>
            <p className="text-gray-700">
              Our platform connects you directly with gas station owners, operators, and investors who are actively 
              engaged in analyzing, improving, and expanding their operations.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          <div className="bg-gray-50 p-6 rounded-lg">
            <Users className="w-8 h-8 text-blue-600 mb-4" />
            <h3 className="text-xl font-bold mb-2">Targeted Audience</h3>
            <p className="text-gray-600">
              Private equity firms, banks, insurance companies, and single- or multi-site operators focused on gas station analytics.
            </p>
          </div>
          
          <div className="bg-gray-50 p-6 rounded-lg">
            <BarChart className="w-8 h-8 text-blue-600 mb-4" />
            <h3 className="text-xl font-bold mb-2">95% Industry Focus</h3>
            <p className="text-gray-600">
              Our users are specifically interested in gas station operations, valuation, and industry benchmarks.
            </p>
          </div>
          
          <div className="bg-gray-50 p-6 rounded-lg">
            <Target className="w-8 h-8 text-blue-600 mb-4" />
            <h3 className="text-xl font-bold mb-2">Premium Placement</h3>
            <p className="text-gray-600">
              Early advertising partners receive category exclusivity and premium placement throughout the platform.
            </p>
          </div>
        </div>

        <h2 className="text-2xl font-bold mb-4">Advertising Options</h2>
        
        <div className="overflow-x-auto mb-8">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-100">
                <th className="border p-3 text-left">Placement</th>
                <th className="border p-3 text-left">Description</th>
                <th className="border p-3 text-left">Visibility</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border p-3 font-medium">Banner Ad</td>
                <td className="border p-3">Prominent placement at the top of all pages</td>
                <td className="border p-3">All users</td>
              </tr>
              <tr className="bg-gray-50">
                <td className="border p-3 font-medium">Featured Vendor</td>
                <td className="border p-3">Priority listing in our vendor directory</td>
                <td className="border p-3">Vendor directory visitors</td>
              </tr>
              <tr>
                <td className="border p-3 font-medium">Dashboard Integration</td>
                <td className="border p-3">Targeted ads within user analytics dashboards</td>
                <td className="border p-3">Registered users</td>
              </tr>
              <tr className="bg-gray-50">
                <td className="border p-3 font-medium">Email Campaigns</td>
                <td className="border p-3">Inclusion in our regular industry updates</td>
                <td className="border p-3">Subscribed users</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="text-center">
          <h3 className="text-xl font-bold mb-4">Ready to reach our audience?</h3>
          <p className="text-gray-600 mb-6">
            Contact our advertising team to discuss custom packages tailored to your marketing goals.
          </p>
          <a
            href="mailto:contact@thefuelcentral.com"
            className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors text-lg"
          >
            Contact Us
          </a>
        </div>
      </div>
    </div>
  );
}
